<template>
    <div class="main-content-container container-fluid px-4">
        <!-- Page Header -->
        <div class="page-header row no-gutters py-4">
            <div class="col-12 flex-header text-center text-sm-left mb-0">
                <h3 class="page-title">Święta</h3>
                <d-button
                  theme="success"
                  @click="addHoliday">
                  <i class="material-icons">add</i> Nowe święto
                </d-button>
            </div>
        </div>

        <!-- Default Light Table -->
        <template v-if="loadError">
            <d-alert
                show
                theme="warning">
                Wczytywanie danych nie powiodło się.
                <a
                    href="javascript:window.location.reload();"
                    class="alert-link">
                    Odśwież stronę
                </a>
                aby spróbować ponownie.
            </d-alert>
        </template>
        <template v-else>
            <transition name="fade">
                <d-card class="card-small">
                    <div
                        v-if="!loaded"
                        class="overlay-loading">
                        <h2 class="preloader isLoading">Trwa ładowanie</h2>
                    </div>
                    <d-card-header class="border-bottom flex-header">
                        <h6 class="m-0">Lista świąt i dni wolnych</h6>
                    </d-card-header>
                    <d-card-body class="p-0 pb-2 text-center">
                        <table class="table mb-0 responsive-table">
                            <thead class="bg-light">
                                <tr>
                                    <th scope="col" class="border-0 text-left">Nazwa święta</th>
                                    <th scope="col" class="border-0">Data</th>
                                    <th scope="col" class="border-0">Rodzaj</th>
                                    <th scope="col" class="border-0 action-cell">Akcja</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="(holiday, index) in holidays"
                                    :key="holiday.id">
                                    <td class="text-left">
                                        <dt>Nazwa święta</dt>
                                        <dd>
                                            {{ holiday.name }}
                                        </dd>
                                    </td>
                                    <td>
                                        <dt>data</dt>
                                        <dd>
                                            {{ holiday.holiday_date }}
                                        </dd>
                                    </td>
                                    <td>
                                        <dt>data</dt>
                                        <dd>
                                            {{ holiday.static === 1 ? 'Statyczne' : 'Ruchome' }}
                                        </dd>
                                    </td>
                                    <td>
                                        <dt>Akcja</dt>
                                        <dd
                                            v-if="holiday.static !== 1"
                                            class="wsnw" >
                                            <d-button
                                                :disabled="actionInProgress"
                                                @click.prevent="editHoliday(holiday)"
                                                class="mr-3">
                                                <i class="material-icons">edit</i> Edytuj
                                            </d-button>
                                            <d-button
                                                theme="danger"
                                                :disabled="actionInProgress"
                                                @click.prevent="removeHoliday(holiday)">
                                                <i class="material-icons">delete</i> Usuń
                                            </d-button>
                                        </dd>
                                    </td>
                                </tr>
                                <tr v-if="holidays.length === 0">
                                    <td colspan="4" class="text-center text-info">
                                        Brak świąt do wyświetlenia&hellip;
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </d-card-body>
                    <d-card-footer>
                        <ss-pagination
                            :meta-data="paginationMetaData"
                            :initial-page="currentPage" />
                    </d-card-footer>
                </d-card>
            </transition>
        </template>
        <holiday-modal
            :holiday-to-edit="selectedHoliday"
            :show="isHolidayModalVisible" />
    </div>
</template>

<script>
import HasPagination from '@/mixins/HasPagination.vue';
import HolidayModal from '@/components/holidays/HolidayModal';
import LarErrors from '@/helpers/Errors';
import ListUtils from '@/utils/ListUtils.js';
import SsPagination from '@/components/common/SsPaginationNew';

export default {
    name: 'HolidaysList',
     mixins: [HasPagination],
    components: {
        HolidayModal,
        LarErrors,
        SsPagination
    },
    data () {
        return {
            lar_errors: LarErrors,
            holidays: [],
            holiday: {
                name: '',
                holiday_date: ''
            },
            loaded: false,
            loadError: false,
            actionInProgress: false,
            selectedHoliday: {},
            isHolidayModalVisible: false
        }
    },
    mounted () {
        this.$bus.$on('holiday-modal-hide', this.closeHolidayModal);
        this.loadItemsData();
    },
    methods: {
        loadItemsData () {
            ListUtils.loadItemsData(this, {
                method: 'post',
                endpoint: '/api/holidays/items',
                listField: 'holidays',
                pagination: true,
                params: {
                    page: this.currentPage
                }
            });
        },
        debouncedLoadFilteredData: _.debounce(function () {
            Vue.set(this, 'loaded', false);
            Vue.set(this, 'loadError', false);
            this.loadItemsData();
        }, 500),
        removeHoliday (holiday) {
            ListUtils.removeItem(this, {
                endpointBase: '/api/holidays/delete/' + holiday.id,
                id: null,
                successTitle: 'Święto zostało usunięte.',
                successText: '',
                confirmTitle: 'Uwaga',
                confirmText: 'Czy potwierdzasz usunięcie  święta<br /><strong>' + holiday.name + '</strong>?',
                errorTitle: 'Wystąpił błąd',
                errorText: 'Usuwanie święta nie powiodło się. Spróbuj ponownie.',
                confirmButtonText: 'Tak',
                cancelButtonText: 'Nie',
                successAction: () => {
                    this.actionInProgress = false;
                    this.debouncedLoadFilteredData();
                },
                failAction: () => {
                    this.actionInProgress = false;
                },
                cancelAction: () => {
                    this.actionInProgress = false;
                },
            });
        },
        editHoliday (holiday) {
            this.selectedHoliday = { ...holiday};
            this.isHolidayModalVisible = true;
        },
        addHoliday () {
            this.selectedHoliday = {};
            this.isHolidayModalVisible = true;
        },
        closeHolidayModal (shouldReload) {
            this.isHolidayModalVisible = false;
            this.selectedHoliday = {};
            if (shouldReload) {
                this.debouncedLoadFilteredData();
            }
        }
    },
    beforeDestroy() {
        this.$bus.$off('holiday-modal-hide', this.closeHolidayModal);
    }
}
</script>
